import React from 'react';

interface VolumeTableContainerProps {
  children: React.ReactNode;
  width?: string;
  marginTop?: string;
}

const VolumeTableContainer: React.FC<VolumeTableContainerProps> = ({
  children,
  width = '400px',
  marginTop = '0',
}): React.ReactElement => {
  return (
    <div
      className="h-full min-w-0 shrink-0 overflow-hidden box-border border-0 transition-[width] duration-300 ease-out translate-x-0 bg-[var(--secondary-outlined-ActiveBg,#D6F6F1)]"
      style={{
        marginTop: marginTop,
        width: width,
      }}
    >
      {children}
    </div>
  );
};

export default VolumeTableContainer;
